import Splide from '@splidejs/splide';

const hero = document.querySelector('.hero');
const heroSlider = document.querySelector('.hero .hero__slider');

// hero slider
if( hero && heroSlider ) {
    var splide = new Splide( '.hero__slider' , {
        type: 'fade',
        rewind: true,
        speed: 4000,
        interval: 7000,
        autoplay: true,
        arrows: false,
        pagination: false,
        perPage: 1,
        perMove: 1
    });
    splide.mount();
}